__turbopack_context__.v({
  "text": "Nr6Q3G_text",
});
